/**
 * Light/dark theme contract — `html[data-theme]`, `localStorage['selected-theme']`, `portalTheme` query.
 * Single source for allowed values; compare and branch using these symbols.
 */
export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type ThemeModeId = (typeof ThemeMode)[keyof typeof ThemeMode];

export function isThemeMode(value: string | null | undefined): value is ThemeModeId {
  return value === ThemeMode.LIGHT || value === ThemeMode.DARK;
}

/** Default when storage is missing. */
export const DEFAULT_THEME_MODE: ThemeModeId = ThemeMode.LIGHT;
